import qs from 'qs';

import kakaoAppClientId from '@app/constants/kakaoAppClientId';

export type KakaoOAuthState =
  | { mode: 'autoLogin'; redirectTo: string }
  | { mode: 'autoLoginOrSignUp' }
  | { mode: 'signUp' }
  | {
      mode: 'signUpAndShareDocument';
      documentId: string;
      isLastOrder: boolean;
      participantId: string;
    }
  | { mode: 'postmessage'; windowName: string };

export function redirectToKakaoOAuthPage(state: KakaoOAuthState) {
  window.location.replace(
    `https://kauth.kakao.com/oauth/authorize?${qs.stringify({
      // eslint-disable-next-line camelcase
      client_id: kakaoAppClientId,
      // eslint-disable-next-line camelcase
      redirect_uri: `${window.location.origin}/authentication/kakao-callback`,
      // eslint-disable-next-line camelcase
      response_type: 'code',
      state: JSON.stringify(state),
      prompt: ['autoLogin', 'autoLoginOrSignUp'].includes(state.mode) ? 'none' : undefined,
    })}`
  );
}
